import React from 'react';
import { css, cx } from 'styled-system/css';
import { card } from 'styled-system/recipes';

import { Lift } from '@shaojiang/components/motion';
import ShaojiangDate from '@shaojiang/components/ShaojiangDate';
import type { ArticleSummary } from '@shaojiang/data/articles';
import type { Locale } from '@shaojiang/types/i18n';

import { CoverPlate } from './CoverPlate';

const root = css({ h: 'full', p: '3', _nebula: { p: '0' } });
const coverStyle = css({ _nebula: { m: '2', mb: '0', aspectRatio: '16 / 10' } });
const body = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5',
  px: '2.5',
  pt: '4',
  pb: '2.5',
  _nebula: { p: '6', gap: '2' },
});

/** An article in a grid: generated cover, date · topic and title. */
interface ArticleCardProps {
  article: ArticleSummary;
  locale: Locale;
  /** Picks the cover plate */
  index?: number;
  /** Date only, no topic */
  compact?: boolean;
}

export function ArticleCard({ article, locale, index = 0, compact = false }: ArticleCardProps) {
  return (
    <Lift
      href={`/articles/${article.slug}`}
      className={cx(card().root, card({ interactive: true }).root, root)}
    >
      <CoverPlate glyph={article.glyph} plate={index} className={coverStyle} />
      <div className={body}>
        <p
          className={css({
            textStyle: 'label',
            color: 'fg.muted',
            _nebula: { color: 'fg.subtle' },
          })}
        >
          <ShaojiangDate dateString={article.date} locale={locale} />
          {!compact && <> · {article.topic}</>}
        </p>
        <p className={css({ textStyle: 'h4' })}>{article.title}</p>
      </div>
    </Lift>
  );
}
